"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  .Polaris-Card__Section {
    padding-top: 8px;
  }

  .Polaris-Card {
    position: relative;
  }

  .Polaris-Button--iconOnly {
    position: absolute;
    top: 22px;
    right: 22px;
  }

  .Polaris-Button__Content {
    display: flex;
    flex-direction: row-reverse;
  }

  .Polaris-Button__Text {
    margin-left: 0;
    margin-right: 7px;
  }
`;
